import * as VueRouter from 'vue-router'
import routes from './routes'
import qs from 'query-string'
import {checkPermissions} from "./utils";

const router = VueRouter.createRouter({
    routes,
    linkActiveClass: 'is-active',
    history: VueRouter.createWebHistory(process.env.APP_URL),
})


router.beforeEach((to, from, next) => {
    let loggedIn = Laravel.currentUser && Laravel.currentUser.id

    window.prevRoute = from

    let meta = to.meta

    // by default all routes require auth
    if (meta.guestRoute === true && loggedIn) {
        return next(Laravel.currentUser.role === 'employee' ? '/projects' : '/dashboard')
    } else if (meta.guestRoute !== true && !loggedIn) {
        return next('/login')
    }

    if (Laravel.currentUser && meta.requiresPermission && Laravel.currentUser.role !== "admin") {
        const hasPermission = checkPermissions(meta.requiresPermission, Laravel.currentUser.permissions);
        if (!hasPermission) {
            return next('/404')
        }
    }

    if (meta.adminRoute === true && Laravel.currentUser.role !== 'admin') {
        return next('/404')
    }

    next()
})

export default router;
